import { render, staticRenderFns } from "./IncomeAndExpenditureProjectionsForTaxPurposes.vue?vue&type=template&id=2e552cf6&scoped=true&"
import script from "./IncomeAndExpenditureProjectionsForTaxPurposes.vue?vue&type=script&lang=js&"
export * from "./IncomeAndExpenditureProjectionsForTaxPurposes.vue?vue&type=script&lang=js&"
import style0 from "./IncomeAndExpenditureProjectionsForTaxPurposes.vue?vue&type=style&index=0&id=2e552cf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e552cf6",
  null
  
)

export default component.exports